import { createContext, useContext } from "react";

import { type SnackbarMessage } from "@/types/types";

type ShowSnackbarType = (message: SnackbarMessage) => void;
export const SnackbarContext = createContext<ShowSnackbarType>(() => {});

export const useSnackbar = () => useContext(SnackbarContext);
